import { RootState } from "../../../store";

export const currentAccountSelectedRegionsSelector = (state: RootState) =>
  state.account.regions;
